<template>
  <div style="display: inline-block" @mouseleave="resetRating">
    <span v-for="n in maxRating" :key="n">
      <span :class="starCssClass(n)" @click="selectRating(n)" @mousemove="highlightStars(n)"></span>
    </span>
  </div>
</template>
<script>
export default {
  data () {
    return {
      maxRating: 5,
      highlightedStars: 0,
      rating: 0
    }
  },

  methods: {
    starCssClass (number) {
      const cssClasses = 'dbs_pr-common-rating-input__star dbs_pr-common-rating-input__star--'
      if (number > this.highlightedStars) {
        return `${cssClasses}off`
      }

      return `${cssClasses}on`
    },

    resetRating () {
      this.highlightedStars = this.rating
    },

    selectRating (number) {
      this.rating = number
      this.$emit('rating-changed', {rating: this.rating})
    },

    highlightStars (number) {
      this.highlightedStars = number
    }
  }
}
</script>
<style lang="scss">
  .dbs_pr-common-rating-input {
    &__star {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url('../../static/images/star.png');
      background-repeat: no-repeat;
      cursor: pointer;

      &--on {
        background-position: -80px 0;
      }

      &--off {
        background-position: -96px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RatingInput.vue